import MessageThread from '@/components/feature/MessageThread';

interface Props {
  tenantId: string;
  clientId: string;
  clientName: string;
  onClose: () => void;
}

export default function MessagesModal({ tenantId, clientId, clientName, onClose }: Props) {
  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white border border-slate-200 rounded-2xl w-full max-w-lg mx-4 flex flex-col overflow-hidden shadow-xl"
        style={{ height: '560px' }}>

        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100 shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#C8A96E]/10 text-[#9a7840] font-semibold text-sm shrink-0">
              {clientName.charAt(0)}
            </div>
            <div>
              <p className="text-[#0f172a] font-semibold text-sm">{clientName}</p>
              <div className="flex items-center gap-1.5 mt-0.5">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
                <p className="text-slate-400 text-xs">Client Conversation</p>
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-[#0f172a] hover:bg-slate-100 rounded-lg transition-all cursor-pointer"
          >
            <i className="ri-close-line"></i>
          </button>
        </div>

        {/* Thread */}
        <div className="flex-1 min-h-0">
          <MessageThread
            tenantId={tenantId}
            clientId={clientId}
            senderType="admin"
            clientName={clientName}
          />
        </div>
      </div>
    </div>
  );
}
